// source: type/order_recipient_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.OrderRecipientInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderRecipientInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderRecipientInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderRecipientInfo.displayName = 'proto.type.OrderRecipientInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderRecipientInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderRecipientInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderRecipientInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderRecipientInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    familyNameKana: jspb.Message.getFieldWithDefault(msg, 4, ""),
    firstNameKana: jspb.Message.getFieldWithDefault(msg, 5, ""),
    note: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderRecipientInfo as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderRecipientInfo.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.familyName;

  /** @type {?|undefined} */
  this.firstName;

  /** @type {?|undefined} */
  this.familyNameKana;

  /** @type {?|undefined} */
  this.firstNameKana;

  /** @type {?|undefined} */
  this.note;

  /** @type {?|undefined} */
  this.isDeleted;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderRecipientInfo.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderRecipientInfo}
 */
proto.type.OrderRecipientInfo.fromObject = function(obj) {
  var msg = new proto.type.OrderRecipientInfo();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  obj.familyName != null && jspb.Message.setField(msg, 2, obj.familyName);
  obj.firstName != null && jspb.Message.setField(msg, 3, obj.firstName);
  obj.familyNameKana != null && jspb.Message.setField(msg, 4, obj.familyNameKana);
  obj.firstNameKana != null && jspb.Message.setField(msg, 5, obj.firstNameKana);
  obj.note != null && jspb.Message.setField(msg, 6, obj.note);
  obj.isDeleted != null && jspb.Message.setField(msg, 7, obj.isDeleted);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderRecipientInfo}
 */
proto.type.OrderRecipientInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderRecipientInfo;
  return proto.type.OrderRecipientInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderRecipientInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderRecipientInfo}
 */
proto.type.OrderRecipientInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyNameKana(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstNameKana(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderRecipientInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderRecipientInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderRecipientInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderRecipientInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFamilyNameKana();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirstNameKana();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsDeleted();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string family_name = 2;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string family_name_kana = 4;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getFamilyNameKana = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setFamilyNameKana = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string first_name_kana = 5;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getFirstNameKana = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setFirstNameKana = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string note = 6;
 * @return {string}
 */
proto.type.OrderRecipientInfo.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_deleted = 7;
 * @return {boolean}
 */
proto.type.OrderRecipientInfo.prototype.getIsDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.OrderRecipientInfo} returns this
 */
proto.type.OrderRecipientInfo.prototype.setIsDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


goog.object.extend(exports, proto.type);
